import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { formatCompactMoney } from "@/lib/api";

export default function KpiCard({
  label,
  value,
  icon: Icon,
  trend,
  trendLabel,
  money = false,
  suffix = "",
  testId,
  tone = "navy",
}) {
  const positive = trend > 0;
  const negative = trend < 0;
  const toneClasses = {
    navy: "bg-navy-600 text-white border-navy-600",
    light: "bg-white text-navy-600 border-slate-200",
  };
  const display =
    value == null
      ? "—"
      : money
      ? formatCompactMoney(value)
      : typeof value === "number"
      ? value.toLocaleString()
      : value;

  return (
    <div
      data-testid={testId}
      className={[
        "group rounded-md border p-5 transition-all",
        toneClasses[tone] || toneClasses.light,
        tone === "light" ? "shadow-sm hover:shadow-md" : "shadow-[0_1px_0_rgba(11,26,48,0.4)]",
      ].join(" ")}
    >
      <div className="flex items-center justify-between">
        <span
          className={[
            "text-[10px] font-semibold uppercase tracking-[0.16em]",
            tone === "navy" ? "text-slate-400" : "text-slate-500",
          ].join(" ")}
        >
          {label}
        </span>
        {Icon && (
          <div
            className={[
              "flex h-7 w-7 items-center justify-center rounded-sm",
              tone === "navy" ? "bg-brand-orange/20 text-brand-orange" : "bg-brand-orange/10 text-brand-orange",
            ].join(" ")}
          >
            <Icon className="h-3.5 w-3.5" />
          </div>
        )}
      </div>
      <div className="mt-4 font-display text-3xl font-semibold tracking-tight tabular">
        {display}
        {suffix && <span className="ml-1 text-lg font-medium opacity-70">{suffix}</span>}
      </div>
      {trend !== undefined && trend !== null && (
        <div className="mt-3 flex items-center gap-1.5 text-xs">
          <span
            className={[
              "inline-flex items-center gap-0.5 rounded-sm px-1.5 py-0.5 font-semibold tabular",
              positive
                ? "bg-emerald-500/15 text-emerald-500"
                : negative
                ? "bg-red-500/15 text-red-500"
                : "bg-slate-500/15 text-slate-400",
            ].join(" ")}
          >
            {positive ? <ArrowUpRight className="h-3 w-3" /> : negative ? <ArrowDownRight className="h-3 w-3" /> : null}
            {Math.abs(trend).toFixed(1)}%
          </span>
          <span className={tone === "navy" ? "text-slate-400" : "text-slate-500"}>
            {trendLabel || "vs prior period"}
          </span>
        </div>
      )}
    </div>
  );
}
